// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;

const html = String.raw

const buildProductUrlWithNoCollection = (data) => {
	return `/products/${data.handle}`
}

// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: 48,
		loadProductFirst: true,
		numberFilterTree: 2,
		filterTreeMobileStyle: 'style2'
	}
};

function setAttributes(el, attrs) {
	for (var key in attrs) {
		el.setAttribute(key, attrs[key]);
	}
}

(function () {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		firstVariant = null,
		boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		var soldOutVariantsString = data.metafields.find(function (metafield) {
			return metafield.key === 'sold_out_variants';
		})?.value;
		var soldOutVariantsPrep = soldOutVariantsString && JSON.parse(soldOutVariantsString);
		// Get first sellable variant (same rules as inline swatches in buildProductOptionSwatches)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (isVariantAvailable(data['variants'][i], soldOutVariantsPrep)) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		reconcilePriceVariation(data);
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	let count = 0;
	ProductGridItem.prototype.compileTemplate = function (data) {
		count++;
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		if (window.marketing_blocks?.length > 0) {
			var marketing_block = window.marketing_blocks.filter((x) => { return x.id === count });
			if (marketing_block !== undefined && marketing_block.length) {
				marketing_block.forEach((block) => {
					itemHtml = buildMarketingBlock(block.content) + itemHtml;
				});
			}
		}

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

		// Add Card product class
		itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass());
		// Add sold out Label
		itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
		// Add sale Label
		itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
		// Add Badges 
		itemHtml = itemHtml.replace(/{{itemBadges}}/g, buildBadges(data));
		// Add Description
		itemHtml = itemHtml.replace(/{{itemDescription}}/g, buildDescription(data));
		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

		// Add Color Swatches
		itemHtml = itemHtml.replace(/{{itemSwatches}}/g, buildProductOptionSwatches(data));

		// Marks the card root as a bundle in the same pass that builds its HTML, so the class is
		// in the markup on the first frame rather than applied by wc-bundle-card.js after its
		// Storefront lookup. CSS hangs the option row's display:none off this - belt to the
		// braces of buildProductOptionSwatches returning '', so a renderer that regresses, or a
		// path that fills the row later, still cannot flash swatches onto a bundle card.
		itemHtml = itemHtml.replace(
			/{{itemBundleClass}}/g,
			isBundleCard(data) ? 'wc-product-card--bundle' : ''
		);

		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildProductReviews(data));
		}

		itemHtml = itemHtml.replace(/{{itemButton}}/g, buildButton(data));

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, buildProductUrlWithNoCollection(data));
		itemHtml = itemHtml.replace(/{{itemCalloutMessage}}/g, buildPromoCallout(data))
		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/


	function buildMarketingBlock(data) {
		var html = '',
			content_color = '',
			html_cta = '';
		if (data.content_color !== '' && data.content_color !== undefined) {
			if (data.content_color == 'Light') {
				content_color = 'color: #fff;';
			} else {
				content_color = 'color: #000;';
			}
		}
		if (data.cta_copy !== '' && data.cta_copy !== undefined && data.cta_url !== '' && data.cta_url !== undefined) {
			html_cta += '<a href="' + data.cta_url + '" class="cta" style="' + content_color + '">';
			html_cta += '<span>' + data.cta_copy + '</span>';
			html_cta += '</a>';
		}
		if (data.block_layout === "1 Columns") {

			const imageWrapClass = !data.content_title && !data.content_copy && !html_cta
				? 'image-wrap image-wrap__no-content'
				: 'image-wrap';

			html += '<div class="card-wrapper marketing_single_card">';
			html += `<div class="card-content animate fade"><div class="${imageWrapClass}">`;
			if (data.image !== '' && data.image !== undefined) {
				html += '<a href="' + data.cta_url + '" class="cta" style="' + content_color + '">';
				html += '<img src="' + data.image + '" alt=""/>';
				html += '</a>';
			}
			if (data.content_title !== '' && data.content_title !== undefined) {
				html += '<a href="' + data.cta_url + '" class="cta" style="' + content_color + '">';
				html += '<h6 style="' + content_color + '" class="card-content__headline">' + data.content_title + '</h6>';
				html += '</a>';
			}
			html += '</div>';
			html += '<div class="card-content-bottom">';
			if (data.content_copy !== '' && data.content_copy !== undefined) {
				html += '<p style="' + content_color + '">' + data.content_copy + '</p>';
			}
			html += html_cta;
			html += '</div>';
			html += '</div>';
			html += '</div>';
		} else {
			html += '<div class="card-wrapper marketing_two_card">';
			html += '<div class="card-content animate fade">';
			if (data.image !== '' && data.image !== undefined) {
				html += '<a href="' + data.cta_url + '" class="cta" style="' + content_color + '">';
				html += '<img src="' + data.image + '" alt=""/>';
				html += '</a>';
			}
			html += '<div class="card-content-bottom">';
			if (data.content_title !== '' && data.content_title !== undefined) {
				html += '<a href="' + data.cta_url + '" class="cta cta__title" style="' + content_color + '">';
				html += '<h6 style="' + content_color + '" class="card-content__headline">' + data.content_title + '</h6>';
				html += '</a>';
			}
			if (data.content_copy !== '' && data.content_copy !== undefined) {
				html += '<p style="' + content_color + '">' + data.content_copy + '</p>';
			}
			html += html_cta;
			html += '</div>';
			html += '</div>';
			html += '</div>';
		}
		return html;
	}

	// Build Product Reviews

	function buildProductReviews(data) {
		let productReviewsHtml = '';
		let reviews = parseFloat(data.metafields.find(x => x.key === "reviews_average")?.value);
		if (!isNaN(reviews)) {
			var empty = Math.floor(5 - reviews);
			var decimal = reviews - Math.floor(reviews);
			var full = reviews - decimal;
			for (let i = 1; i <= full; i++) {
				productReviewsHtml += '<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.08332 0L8.82463 4.13363L13.3444 4.49139L9.90082 7.40387L10.9529 11.7586L7.08332 9.425L3.21374 11.7586L4.26582 7.40387L0.822211 4.49139L5.34201 4.13363L7.08332 0Z" fill="black"></path></svg>';
			}
			if (decimal > 0) {
				if (decimal >= 0.5) {
					productReviewsHtml += '<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.25031 0L8.99162 4.13363L13.5114 4.49139L10.0678 7.40387L11.1199 11.7586L7.25031 9.425L3.38073 11.7586L4.43281 7.40387L0.989203 4.49139L5.509 4.13363L7.25031 0Z" fill="#CCCCCC"></path><path d="M7.24939 0L7.24944 4.13363V7.40388L7.24939 9.425L3.37981 11.7586L4.43189 7.40388L0.988281 4.49139L5.50808 4.13363L7.24939 0Z" fill="black"></path></svg>';
				} else {
					productReviewsHtml += '<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.08332 0L8.82463 4.13363L13.3444 4.49139L9.90082 7.40387L10.9529 11.7586L7.08332 9.425L3.21374 11.7586L4.26582 7.40387L0.822211 4.49139L5.34201 4.13363L7.08332 0Z" fill="#CCCCCC"></path></svg>';
				}
			}
			for (let i = 1; i <= empty; i++) {
				productReviewsHtml += '<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.08332 0L8.82463 4.13363L13.3444 4.49139L9.90082 7.40387L10.9529 11.7586L7.08332 9.425L3.21374 11.7586L4.26582 7.40387L0.822211 4.49139L5.34201 4.13363L7.08332 0Z" fill="#CCCCCC"></path></svg>';
			}
		}
		return productReviewsHtml;
	}

	var decimalPricingCache = {};

	function hasDecimalPricing(data) {
		const tag = boostPFSThemeConfig.custom.product_tag_decimal_pricing;
		return Boolean(tag && data.tags?.includes(tag));
	}

	function parseVariantPrice(price) {
		return parseFloat(price);
	}

	function fetchShopifyDecimalPrices(handle, forceRefresh) {
		if (forceRefresh) {
			delete decimalPricingCache[handle];
			delete decimalPricingCache[handle + '_pending'];
		}
		if (decimalPricingCache[handle]) {
			return Promise.resolve(decimalPricingCache[handle]);
		}
		if (decimalPricingCache[handle + '_pending']) {
			return decimalPricingCache[handle + '_pending'];
		}

		decimalPricingCache[handle + '_pending'] = fetch('/products/' + handle + '.js')
			.then(function (response) {
				return response.json();
			})
			.then(function (product) {
				var variantPrices = {};
				product.variants.forEach(function (variant) {
					variantPrices[variant.id] = variant.price / 100;
				});
				var prices = Object.values(variantPrices);
				decimalPricingCache[handle] = {
					variantPrices: variantPrices,
					price_min: Math.min.apply(null, prices),
					price_max: Math.max.apply(null, prices),
				};
				delete decimalPricingCache[handle + '_pending'];
				return decimalPricingCache[handle];
			})
			.catch(function () {
				delete decimalPricingCache[handle + '_pending'];
				return null;
			});

		return decimalPricingCache[handle + '_pending'];
	}

	function prefetchDecimalPricingProducts(products) {
		if (!products) return;
		products.filter(hasDecimalPricing).forEach(function (product) {
			fetchShopifyDecimalPrices(product.handle, true);
		});
	}

	function getVariantPriceDollars(variant, data) {
		if (hasDecimalPricing(data)) {
			var cached = decimalPricingCache[data.handle];
			if (cached && cached.variantPrices) {
				var accuratePrice = cached.variantPrices[variant.id];
				if (accuratePrice === undefined) {
					accuratePrice = cached.variantPrices[String(variant.id)];
				}
				if (accuratePrice !== undefined) {
					return accuratePrice;
				}
			}
		}
		return parseVariantPrice(variant.price);
	}

	function findProductCard(productId) {
		var favoriteBtn = document.querySelector('rivo-favorite-button[data-product-id="' + productId + '"]');
		return favoriteBtn ? favoriteBtn.closest('.card-wrapper') : null;
	}

	function updateProductCardPrices(product) {
		if (!hasDecimalPricing(product) || !decimalPricingCache[product.handle]) return;

		var card = findProductCard(product.id);
		if (!card) return;

		var prices = product.variants.map(function (variant) {
			return getVariantPriceDollars(variant, product);
		}).filter(function (price) {
			return !isNaN(price);
		});

		if (!prices.length) return;

		var displayPrice;
		if (boostPFSThemeConfig.custom.product_card_use_first_variant) {
			var firstAvailableVariant = product.variants[0];
			for (var i = 0; i < product.variants.length; i++) {
				if (isVariantAvailable(product.variants[i])) {
					firstAvailableVariant = product.variants[i];
					break;
				}
			}
			displayPrice = getVariantPriceDollars(firstAvailableVariant, product);
		} else {
			displayPrice = Math.min.apply(null, prices);
		}

		card.querySelectorAll(
			'.product-cart-button .price-item--sale, .product-cart-button .price__second .price-item--sale, .button-price .price-item--sale'
		).forEach(function (priceEl) {
			priceEl.textContent = formatMoneyPrice(displayPrice, true);
		});

		card.querySelectorAll('.option-selector label[data-variant-id]').forEach(function (label) {
			var variant = product.variants.find(function (v) {
				return String(v.id) === String(label.dataset.variantId);
			});
			if (variant) {
				label.dataset.variantPrice = formatMoneyPrice(getVariantPriceDollars(variant, product), true);
			}
		});
	}

	function refreshDecimalPricingCards(products) {
		if (!products || !products.length) return Promise.resolve();

		var decimalProducts = products.filter(hasDecimalPricing);
		if (!decimalProducts.length) return Promise.resolve();

		return Promise.all(
			decimalProducts.map(function (product) {
				return fetchShopifyDecimalPrices(product.handle, true);
			})
		).then(function () {
			decimalProducts.forEach(updateProductCardPrices);
		});
	}

	function reconcilePriceVariation(data) {
		if (!data.variants?.length) return;

		var prices = data.variants.map(function (variant) {
			return getVariantPriceDollars(variant, data);
		}).filter(function (price) {
			return !isNaN(price);
		});

		var comparePrices = data.variants.map(function (variant) {
			return parseVariantPrice(variant.compare_at_price) || 0;
		}).filter(function (price) {
			return price > 0;
		});

		if (!prices.length) return;

		if (boostPFSThemeConfig.custom.product_card_use_first_variant && firstVariant) {
			data.price_min = getVariantPriceDollars(firstVariant, data);
			data.price_max = data.price_min;
		} else {
			data.price_min = Math.min.apply(null, prices);
			data.price_max = Math.max.apply(null, prices);
		}

		if (comparePrices.length) {
			data.compare_at_price_min = Math.min.apply(null, comparePrices);
		}

		onSale = data.compare_at_price_min > data.price_min;
		priceVaries = data.price_min !== data.price_max;
	}

	function formatMoneyPrice(price = 0, useDecimalPricing = false) {
		var numericPrice = parseVariantPrice(price);
		if (isNaN(numericPrice)) numericPrice = 0;
		if (useDecimalPricing) {
			return Utils.formatMoney(numericPrice, '${{amount}}');
		}
		return Utils.formatMoney(numericPrice).replace('.00', '');
	}

	function getProductHandleFromCard(card) {
		if (!card) return null;
		var link = card.querySelector('a.full-unstyled-link, a[href*="/products/"]');
		if (!link) return null;
		var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
		return match ? match[1] : null;
	}

	function resolveSwatchVariantPrice(label) {
		if (label.dataset.variantPrice) {
			return label.dataset.variantPrice;
		}

		var card = label.closest('.card-wrapper');
		var handle = getProductHandleFromCard(card);
		var cached = handle ? decimalPricingCache[handle] : null;

		if (cached && cached.variantPrices) {
			var variantId = label.dataset.variantId;
			var accuratePrice = cached.variantPrices[variantId];
			if (accuratePrice === undefined) {
				accuratePrice = cached.variantPrices[String(variantId)];
			}
			if (accuratePrice !== undefined) {
				return formatMoneyPrice(accuratePrice, true);
			}
		}

		return '';
	}

	function updateProductCartButtonPrice(cartButton, variantPrice) {
		if (!cartButton || !variantPrice) return;

		cartButton.querySelectorAll(
			'.price__second .price-item--sale, .price__second span, .price__sale .price-item--sale'
		).forEach(function (priceEl) {
			priceEl.textContent = variantPrice;
		});
	}

	// Build Color Swatches
	// Mirrors the featured-card option markup in snippets/product-card.liquid: a
	// `.featured-product-card__option-track` wrapper (scrollable + prev/next nav for colours) so
	// featured-product-card.js can wire up the carousel, and the same class per option type.
	// Keep the two in sync - the collection/search grid and the Featured Products carousel are
	// meant to render identically.
	// A Shopify native bundle is configured on its PDP, so its card links out instead of adding
	// to the bag. product_type cannot be used here - the store types real bundles and legacy
	// hand-built sets alike as "Sets". custom.is_bundle carries the verdict; Boost only forwards
	// metafields it has been told to index, so when the key is absent wc-bundle-card.js resolves
	// the card from ProductVariant.requiresComponents instead. Returns '' for that case - it is
	// what signals "not yet known" rather than "not a bundle".
	function getBundleVerdict(data) {
		// Boost returns only the metafields it has been told to index - on this store that is
		// callout_message and sold_out_variants, not is_bundle - so this almost always returns ''
		// and the option-name fallback is what actually answers. Guarded because isBundleCard is
		// now asked about every product, not just ones that reached the CTA builder.
		const metafields = Array.isArray(data?.metafields) ? data.metafields : [];
		const bundleMetafield = metafields.find((metafield) => metafield.key === 'is_bundle')?.value;
		if (bundleMetafield === undefined) return '';
		return String(bundleMetafield === 'true' || bundleMetafield === true);
	}

	// Shopify names a bundle's options "<Component product> (Shade)" / "(Color)" / "(Size)" to
	// disambiguate components that share an option name - wc-product-form.liquid strips exactly
	// these suffixes to title each component's card on the PDP. A normal product's option is the
	// bare word, never prefixed.
	//
	// Boost exposes that name twice and NEITHER is the Shopify string by default: `name` and
	// `original_name` are handleized, so "Hydro Grip Hydrating Gel Skin Tint (Color)" arrives as
	// `hydro_grip_hydrating_gel_skin_tint_color`, and only `label` keeps the original. Matching on
	// `name` alone with a parenthesised pattern silently never fires - which is exactly how the
	// swatches kept flashing after the first attempt at this.
	//
	// So: try the label, then fall back to the handleized form, where the same convention shows up
	// as a trailing `_color` / `_size` with a component prefix in front of it. A plain product's
	// handleized name is just `color` / `size` / `title`, with nothing before the word, so the
	// leading separator is what distinguishes the two.
	const BUNDLE_OPTION_LABEL = /\s*\(\s*(colou?r|shade|size)\s*\)\s*$/;
	const BUNDLE_OPTION_HANDLE = /[_-](colou?r|shade|size)$/;

	function isBundleOptionName(option) {
		const label = String(option?.label || '').trim().toLowerCase();
		if (label && BUNDLE_OPTION_LABEL.test(label)) return true;

		const name = String(option?.name || option?.original_name || '').trim().toLowerCase();
		return Boolean(name) && BUNDLE_OPTION_HANDLE.test(name);
	}

	// Every option has to match. One bare name means a real choice the shopper makes on the card.
	function hasBundleOptionNames(data) {
		const options = data.options_with_values;
		if (!Array.isArray(options) || !options.length) return false;
		return options.every(isBundleOptionName);
	}

	// The single question every renderer asks. Metafield first because it is authoritative, then
	// the option names, which need no request and are therefore the only one of the two that can
	// answer before the card paints when Boost has not indexed custom.is_bundle.
	function isBundleCard(data) {
		if (getBundleVerdict(data) === 'true') return true;
		return hasBundleOptionNames(data);
	}

	function buildProductOptionSwatches(data) {
		// A bundle card has nothing to select. Its options are the component choices, which only
		// mean anything in the PDP's bundle builder next to the component image and title - here
		// they are long shade descriptions with no context, and the CTA is "View Set" rather than
		// an add to bag, so there is no variant for a pill to pick. Returning '' also leaves
		// [data-selected-color-name] empty: featured-product-card.js bails out when it finds no
		// option matching the variant, so the value line under the row goes with them.
		if (isBundleCard(data)) return '';

		const soldOutVariantsString = data.metafields.find(metafield => metafield.key === 'sold_out_variants')?.value
		const soldOutVariants = soldOutVariantsString && JSON.parse(soldOutVariantsString)
		let swatchesProductOptionHtml = '';
		if (typeof data.options_with_values != 'undefined' && data.options_with_values.length > 0 && data.options_with_values.length < 2) {
			var swatchArr = data.options_with_values[0];
			var swatchValues = swatchArr.values;
			let optionName = String(swatchArr.name || '').trim().toLowerCase();
			var productImages = data.original_images && data.original_images.length > 0 ? data.original_images : data.images_info;

			// Shopify's placeholder option for single-variant products. Nothing to choose, and
			// rendering it puts a literal "Default Title" pill on the card.
			const isDefaultTitleOption = optionName === 'title'
				&& swatchValues.length === 1
				&& String(swatchValues[0]?.title || '').trim().toLowerCase() === 'default title';
			if (isDefaultTitleOption || swatchValues.length < 2) {
				return '';
			}

			const isColorOption = optionName === 'color' || optionName === 'colour' || optionName === 'shade';
			const isSizeOption = optionName === 'size' || optionName === 'title';

			// Match the pill/swatch that buildButton() preselects: first sellable value in option order.
			let activeIndex = -1;
			for (let aIndex = 0; aIndex < swatchValues.length; aIndex++) {
				if (isVariantAvailable(data['variants'][aIndex], soldOutVariants)) {
					activeIndex = aIndex;
					break;
				}
			}

			for (var sIndex = 0; sIndex < swatchArr.values.length; sIndex++) {
				var swatchName = swatchValues[sIndex].title;
				var swatchVariant = data['variants'][sIndex];
				// Same positional assumption as above - skip rather than throw on a missing variant.
				if (!swatchVariant) { continue; }
				let swatchColor = data.metafields.find(x => x.namespace === swatchVariant.id)?.value;
				let disabled = '';
				let priceFormated = formatMoneyPrice(getVariantPriceDollars(data.variants[sIndex], data), hasDecimalPricing(data));
				let variantImage = data.variants[sIndex].image;
				if (!isVariantAvailable(swatchVariant, soldOutVariants)) {
					disabled = 'disabled';
				}
				var valueColor = '';
				var metaColor = data.metafields.find(meta => meta.id == data.variants[sIndex].id) || {};
				metaColor.value !== 'undefined' ? valueColor = metaColor.value : valueColor = '';

				let featured_media_founded = false;
				let founded_index;
				let alternative_image = '';
				let BreakException = {};
				try {
					productImages.forEach((image, index) => {
						if (data.variants[sIndex].image == image.src) {
							founded_index = sIndex;
						}
						if (data.variants[sIndex].image == image.src || featured_media_founded) {
							featured_media_founded = true;
							if (founded_index == sIndex) {
								if (image.alt?.includes('~alternative')) {
									alternative_image = image.src;
									throw BreakException
								}
								if ((productImages.length - 1) == index) {
									alternative_image = data.variants[sIndex].image;
								}
							} else {
								alternative_image = data.variants[sIndex].image;
							}
						}
					});
				} catch (e) {
					if (e !== BreakException) throw e;
				}
				const activeClass = sIndex === activeIndex ? ' active' : '';
				const sharedAttrs = 'data-variant-alternative-image="' + alternative_image + '"'
					+ ' data-variant-image="' + variantImage + '"'
					+ ' data-variant-price="' + priceFormated + '"'
					+ ' data-variant-id="' + swatchVariant.id + '"';

				if (isColorOption) {
					swatchesProductOptionHtml += '<label ' + sharedAttrs
						+ ' data-color-name="' + swatchName + '"'
						+ ' style="background-color: ' + valueColor + ';"'
						+ ' class="color_option ' + disabled + activeClass + '"></label>';
				} else if (isSizeOption) {
					// No data-unit-measure: Boost does not expose the variant's custom.unit_measure
					// metafield, and featured-product-card.js deliberately renders no label line for a
					// size pill without one (rather than repeating the bare size under the pills).
					swatchesProductOptionHtml += '<label ' + sharedAttrs
						+ ' data-option-name="' + swatchName + '"'
						+ ' class="size_option ' + disabled + activeClass + '">'
						+ '<span>' + swatchName + '</span></label>';
				} else {
					swatchesProductOptionHtml += '<label ' + sharedAttrs
						+ ' data-option-label="' + swatchName + '"'
						+ ' class="default_option ' + disabled + activeClass + '">' + swatchName + '</label>';
				}

			}

			let trackClass = 'featured-product-card__option-track';
			let trackAttrs = '';
			let navPrev = '';
			let navNext = '';

			if (isColorOption) {
				trackClass += ' color-options-track featured-product-card__option-track--scrollable';
				trackAttrs = ' data-featured-option-track';
				navPrev = '<button type="button" class="featured-product-card__option-nav featured-product-card__option-nav--prev" data-featured-option-prev aria-label="Show previous color options">'
					+ '<svg aria-hidden="true" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="featured-product-card__option-nav-icon">'
					+ '<path d="M8 2L2 8L8 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
				navNext = '<button type="button" class="featured-product-card__option-nav featured-product-card__option-nav--next" data-featured-option-next aria-label="Show more color options">'
					+ '<svg aria-hidden="true" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="featured-product-card__option-nav-icon">'
					+ '<path d="M2 2L8 8L2 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
			} else if (isSizeOption) {
				trackClass += ' size-options-track';
			} else {
				trackClass += ' default-options-track';
			}

			swatchesProductOptionHtml = navPrev
				+ '<div class="' + trackClass + '"' + trackAttrs + '>' + swatchesProductOptionHtml + '</div>'
				+ navNext;

		}
		return swatchesProductOptionHtml;
	}

	function isVariantAvailable(variant, soldOutVariants) {
		// Callers index data.variants by option-value position, which is not guaranteed to line up.
		// Without this, a missing variant threw on `variant.id` / `variant.available` - and any
		// exception while the product list renders makes Boost bail out to
		// `?view=boost-pfs-original` (see errorFilterCallback in boost-pfs-core.js), which breaks
		// the theme editor. Treat an absent variant as unavailable.
		if (!variant) return false
		if (soldOutVariants && soldOutVariants.includes(String(variant.id))) return false
		if (typeof variant.available !== 'undefined') return variant.available;
		if (variant.inventory_policy === "continue" || variant.inventory_management !== "shopify") return true;

		return variant.inventory_quantity > 0;
	}


	function buildButton(data) {
		let buttonHtml = '',
			buttonContainerClass = '',
			available_variants = 0,
			selected_or_first_available_variant_id = 0,
			data_variant = '',
			outofstock = '',
			buttonText = '';
		isLink = false;
		const isKit = data.product_type === 'Kit';
		const bundleVerdict = getBundleVerdict(data);
		const isBundle = bundleVerdict === 'true';
		const soldOutVariantsStringBtn = data.metafields.find(function (metafield) {
			return metafield.key === 'sold_out_variants';
		})?.value;
		const soldOutVariantsBtn = soldOutVariantsStringBtn && JSON.parse(soldOutVariantsStringBtn);

		// If it's a gift card just go to gift card page
		if (data.handle == 'rise-ai-giftcard' || data.handle == 'giftcard') {
			buttonText = 'Choose Amount';
			buttonHtml = `
				<div class="product-cart-button">
					<a href="/products/${data.handle}">
						<span class="button-text">${buttonText}</span>
						${buildPrice_card(data)}
					</a>
				</div>
			`;

			return buttonHtml;
		}

		//Sephora
		if (boostPFSThemeConfig.custom.sephora_linking && data.metafields.find(x => x.key === "sephora_linking")) {
			var buttonLink = data.metafields.find(x => x.key === "sephora_linking")?.value;
			buttonText = 'Available At Sephora';
			buttonHtml = `
				<div class="button-sephora-wrap">
					<a class="button-redirect button-redirect-light" href="${buttonLink}" target="_blank">
						<span class="button-text">${buttonText}</span>
						<span class="button-price">${buildPrice_card(data)}</span>
					</a>
				</div>
			`;

			return buttonHtml;
		}

		for (let i = 0; i < data['variants'].length; i++) {
			// Pass the sold_out_variants metafield through - without it, variants marked sold out
			// there still count as available and can get preselected on the button.
			if (isVariantAvailable(data['variants'][i], soldOutVariantsBtn)) {
				if (selected_or_first_available_variant_id == 0) {
					// Was assigning to an undeclared global and never setting the guard, so this
					// ended up holding the LAST available variant instead of the first.
					selected_or_first_available_variant_id = data['variants'][i].id;
				}
				available_variants++;
			}
		}
		if (typeof data.options_with_values != 'undefined' && data.options_with_values.length > 0 && data.options_with_values.length < 2 && available_variants > 1 && !data.tags.includes('force-sign-up')) {
			buttonContainerClass = 'js-open-selectors';
		}

		// Featured cards render the variant picker inline, so a single-option product is already
		// resolved to a concrete variant - add straight to bag rather than sending them to the PDP
		// with "Select Shade"/"Select Size". Mirrors inline_variant_selector in product-card.liquid.
		const inlineVariantSelector = typeof data.options_with_values != 'undefined'
			&& data.options_with_values.length === 1
			&& data['variants'].length > 1
			&& available_variants > 1
			&& !data.tags.includes('force-sign-up')
			&& !data.tags.includes('force-oos')
			&& !isKit;

		if (!data.available) {
			buttonText = 'Out of Stock';
			outofstock = 'outofstock';
		} else if (data.tags.includes('force-sign-up')) {
			buttonText = 'Sign Up Now';
			outofstock = 'outofstock';
			isLink = true
		} else if (data.tags.includes('force-oos')) {
			buttonText = 'Out of Stock';
			outofstock = 'outofstock';
		} else {
			if (isBundle) {
				// No data_variant and no js-open-selectors: the card is a plain link to the PDP.
				buttonText = 'View Set';
			} else if (isKit) {
				buttonText = window.TMW.strings.getTheLook.viewKit;
			} else {
				if (
					available_variants == 1 ||
					data['variants'].length < 2 ||
					typeof data.variant_id !== 'undefined' ||
					inlineVariantSelector
				) {
					buttonContainerClass = 'js-open-selectors';
					if (typeof data.variant_id !== 'undefined') {
						data_variant =
							'data-selected-variant="' +
							data.variant_id +
							'" data-drawer-trigger aria-controls="mini-cart" aria-expanded="false"';
					} else {
						data_variant =
							'data-selected-variant="' +
							selected_or_first_available_variant_id +
							'" data-drawer-trigger aria-controls="mini-cart" aria-expanded="false"';
					}
					buttonText = 'Add to Bag';
				} else if (data.options_with_values.length > 1) {
					buttonText = 'Select Option';
				} else {
					buttonText = 'Select ' + data.options[0];
				}
			}
		}
		const gwpVariant = getGwpProduct(data);

		// Hooks for wc-bundle-card.js. Boost cards are built here rather than in Liquid, so they
		// need the same data-bundle-cta contract as product-card.liquid or the runtime backfill
		// cannot see them - which is the only path when is_bundle is not an indexed Boost metafield.
		const bundleCtaAttributes =
			' data-bundle-cta data-product-url="' +
			buildProductUrlWithNoCollection(data) +
			'" data-card-variant-id="' +
			(typeof data.variant_id !== 'undefined' ? data.variant_id : selected_or_first_available_variant_id) +
			'"' +
			(bundleVerdict ? ' data-is-bundle="' + bundleVerdict + '"' : '');

		buttonHtml +=
			'<div data-gwp-variant="' +
			gwpVariant +
			'" class="product-cart-button ' +
			buttonContainerClass +
			'" ' +
			outofstock +
			' ' +
			data_variant +
			bundleCtaAttributes +
			'>';
		if (
			(data.options_with_values.length > 1 && data.available) ||
			isKit || isLink || (isBundle && data.available)
		) {
			buttonHtml += '<a href="' + buildProductUrlWithNoCollection(data) + '">';
		}
		buttonHtml += '<span class="button-text">' + buttonText + '</span>';
		if (data.available && !isKit && !data.tags.includes('force-oos') && !data.tags.includes('force-sign-up')) {
			buttonHtml += buildPrice_card(data);
		}
		if (
			(data.options_with_values.length > 1 && data.available) ||
			isKit || isLink || (isBundle && data.available)
		) {
			buttonHtml += '</a>';
		}
		buttonHtml += '</div>';
		return buttonHtml;
	}

	function buildTagBadges(data) {
		console.log(data, 'DATA!');
		return data.tags
			.filter(tag => tag.includes('badge'))
			.map(tag => html`
			<div class="single_badge badge_${tag.split(':')[1] ?? ''}">
				<span></span>
			</div>
		`)
			.join('')
	}

	function buildMetafieldBadges(customBadgeMetafield) {
		try {
			const badgesList = document.querySelector('[data-badges]')?.innerHTML
			const parsedBadgesList = JSON.parse(badgesList ?? '{}')
			const metaobjectIdList = JSON.parse(customBadgeMetafield?.value ?? '[]')

			return metaobjectIdList
				.map(metaobjectFullId => {
					const metaobjectId = metaobjectFullId.split('Metaobject/')[1]
					const badgeMetaobjectData = parsedBadgesList[metaobjectId] ?? null
					if (!badgeMetaobjectData) { return '' }

					const badgeText = badgeMetaobjectData.text ?? ''
					const backgroundColor = badgeMetaobjectData.background_color ?? '#000'
					const textColor = badgeMetaobjectData.text_color ?? '#FFF'
					const badgeImage = badgeMetaobjectData.image ?? ''

					return html`
						<div
							class="single_badge custom_badge ${badgeImage ? 'custom_badge--image' : ''}"
							style="${badgeImage ? '' : `background: ${backgroundColor}; color: ${textColor};`}"
						>
							${badgeImage ? `
								<img src="${badgeImage}" alt="${badgeText}" width="75" height="75"/>
							`:
							`<span>${badgeText}</span>`
						}
						</div>
					`
				})
				.join('')
		} catch (err) {
			console.error(err)
			return ''
		}
	}

	function buildBadges(data) {
		const customBadgeMetafield = data?.metafields?.find(metafield => metafield.key === 'badges_list')

		return html`
		<div class="product_badges">
			${(!customBadgeMetafield || !customBadgeMetafield.value) ? buildTagBadges(data) : buildMetafieldBadges(customBadgeMetafield)}
		</div>
	`;
	}

	function buildImages(data) {
		var html = '',
			aspectRatio = '',
			rangeWidths = boostPFSRangeWidths,
			paddingBottom = 100;

		var dataSrcSet = '',
			imgAlt = data.title,
			flipImageSrcSet = '';

		var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
			boostPFSThemeConfig.custom.show_secondary_image == true;

		for (var i = 0; i < rangeWidths.length; i++) {
			dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

			if (activeSwapImage) {
				flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			}

			if (i < rangeWidths.length - 1) {
				dataSrcSet += ', ';

				if (activeSwapImage) {
					flipImageSrcSet += ', ';
				}
			}
		}



		if (images.length > 0) {
			aspectRatio = images[0]['width'] / images[0]['height'];
			paddingBottom = 100;
			var productImages = data.original_images && data.original_images.length > 0 ? data.original_images : data.images_info;

			// data-card-product-link lets featured-product-card.js retarget this at the selected
			// variant, same as the title link and the CTA.
			html += '<div class="media media--transparent media--adapt media--hover-effect" style="padding-bottom: ' + paddingBottom + '%;"><a href="{{itemUrl}}" data-card-product-link>';

			html += '<img class="motion-reduce"' +
				'loading="lazy"' +
				'srcset="' + dataSrcSet + '" ' +
				'height="' + images[0].width + '" ' +
				'width="' + images[0].width + '" ' +
				'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
				'alt="' + imgAlt + '" />';
			let founded_index = 0;
			let next_variant_image_index = 1;
			let featured_media_founded = false;
			let BreakException = {};
			if (images.length == 1 && data.variants.length == 1) {
				var index = productImages.findIndex(function (e) { return e.src == images[0].src });
				if (index > -1) {
					let dataSrcSetAlternative = '';
					for (var i = 0; i < rangeWidths.length; i++) {
						if (productImages[index + 1]?.src != 'undefined') {
							dataSrcSetAlternative += Utils.optimizeImage(productImages[index + 1]?.src, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
						}
						if (i < rangeWidths.length - 1) {
							dataSrcSetAlternative += ', ';
						}
					}
					// Start boost 205603
					var height = productImages[index + 1]?.heigh ? productImages[index + 1].heigh : undefined
					var width = productImages[index + 1]?.width ? productImages[index + 1].width : undefined
					var src = productImages[index + 1]?.src ? Utils.optimizeImage(productImages[index + 1].src, '533x') : undefined
					var alt = productImages[index + 1]?.alt ? productImages[index + 1].alt.replace('~alternative', '') : undefined
					html += '<img class="motion-reduce alternative"' +
						'loading="lazy"' +
						'srcset="' + dataSrcSetAlternative + '" ' +
						'height="' + height + '" ' +
						'width="' + width + '" ' +
						'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
						'src="' + src + '" ' +
						'alt="' + alt + '" />';
					// End boost 205603
				}
			} else {
				var currentImageIndex = productImages.findIndex(x => x.src === images[0].src);
				var image = productImages.slice(currentImageIndex + 1).find(img => img.alt && img.alt.includes('~alternative'));
				if (image) {
					let dataSrcSetAlternative = '';
					for (var i = 0; i < rangeWidths.length; i++) {
						dataSrcSetAlternative += Utils.optimizeImage(image.src, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
						if (i < rangeWidths.length - 1) {
							dataSrcSetAlternative += ', ';
						}
					}

					html += '<img class="motion-reduce alternative"' +
						'loading="lazy"' +
						'srcset="' + dataSrcSetAlternative + '" ' +
						'height="' + image.height + '" ' +
						'width="' + image.width + '" ' +
						'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
						'src="' + Utils.optimizeImage(image.src, '533x') + '" ' +
						'alt="' + image.alt.replace('~alternative', '') + '" />';
				} else {
					let dataSrcSetAlternative = '';
					for (var i = 0; i < rangeWidths.length; i++) {
						dataSrcSetAlternative += Utils.optimizeImage(images[0]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
						if (i < rangeWidths.length - 1) {
							dataSrcSetAlternative += ', ';
						}
					}
					html += '<img class="motion-reduce alternative"' +
						'loading="lazy"' +
						'srcset="' + dataSrcSetAlternative + '" ' +
						'height="' + images[0].height + '" ' +
						'width="' + images[0].width + '" ' +
						'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
						'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
						'alt="' + images[0].alt?.replace('~alternative', '') + '" />';
				}
			}

			html += '</a>';
			html += '</div>';
		}
		return html;
	}

	function buildCardProductClass() {
		var html = '';
		if (!images || (images && images.length === 0)) {
			html = 'card--text-only card--soft';
		} else {
			html = 'card--outline';
		}
		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			boostPFSThemeConfig.custom.show_vendor === true) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildDescription(data) {
		let subtitle = data.metafields.find(x => x.key === "product_subtitle")?.value;
		if (subtitle == undefined) return '';
		var html = jQ('<p>' + subtitle + '</p>').text();
		return html;
	}

	function getGwpProduct(data) {
		const gwp_product = data?.metafields?.find(x => x.key === 'gwp_product')?.value;
		return gwp_product?.split(':')[1];
	}

	function buildPrice_card(data) {
		var html = String.raw;
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
		const useDecimalPricing = hasDecimalPricing(data);
		const formatPrice = (price = 0) => formatMoneyPrice(price, useDecimalPricing);

		let priceHTML;

		if (priceVaries && data.price_min !== data.price_max) {
			let price = boostPFSConfig.label.from_price_html.replace('From ', '').replace(/{{ price }}/, formatPrice(data.price_min) + '-' + formatPrice(data.price_max))
			priceHTML = html`<div class="price__second"><span class="price-item price-item--sale">${price}</span></div>`
		} else if (onSale) {
			priceHTML = html`<div class="price__sale"><span class="price-item price-item--sale">${formatPrice(data.price_min)}</span><span class="price-item price-item--regular">${formatPrice(data.compare_at_price_min)}</span></div>`;
		} else {
			priceHTML = html`<div class="price__sale"><span class="price-item price-item--sale">${formatPrice(data.price_min)}</span></div>`;
		}
		return html`<div class="price">
			${priceHTML}
		</div>`;
	}

	function buildPrice(data) {
		var html = '';
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		const useDecimalPricing = hasDecimalPricing(data);
		const formatPrice = (price = 0) => formatMoneyPrice(price, useDecimalPricing);
		var moneyPrice = priceVaries && data.price_min !== data.price_max
			? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, formatPrice(data.price_min))
			: formatPrice(data.price_min);
		var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
		html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}"
					<dl>
						<div class="price__regular">
							<dt>
								<span class="visually-hidden visually-hidden--inline">
									${boostPFSConfig.label.regular_price}
								</span>
							</dt>
							<dd>
								<span class="price-item price-item--regular">
									${moneyPrice}
						  		</span>
							</dd>
						</div>
						<div class="price__sale">
							<dt class="price__compare">
								<span class="visually-hidden visually-hidden--inline">
									${formatPrice(data.sale_price)}
								</span>
							</dt>
							<dd class="price__compare">
								<s class="price-item price-item--regular">
								${formatPrice(data.compare_at_price_min)}
								</s>
						  	</dd>
							<dt>
							  <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
							</dt>
							<dd class="price__last">
								<span class="price-item price-item--sale">
									${moneyPrice}
								</span>
						  	</dd>
						</div>
						<small class="unit-price caption ${unitPriceClass}">
							<dt class="visually-hidden">${boostPFSConfig.label.unit_price}</dt>
							<dd class="price__last">
								<span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
								<span aria-hidden="true">/</span>
								<span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
							</dd>
					  </small>
					</dl>
				</div>`
		return html;
	}

	function buildSoldOutLabel() {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
		}
		return soldOutLabel;
	}

	function buildSaleLabel() {
		// Build Sale label
		var saleLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
		}
		return saleLabel;
	}




	// Build Color Swatches
	function eventColorSwatches(event) {
		jQ('.boost-pfs-filter-item-swatch li span').each(function () {
			var img = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
			if (event == 'hover') {
				jQ(this).hover(function () {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				});
			}
			if (event == 'click') {
				jQ(this).click(function () {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
					jQ(this).closest('.boost-pfs-filter-product-bottom-inner').find('.boost-pfs-filter-product-item-regular-price').html(jQ(this).data('price'));

				});
			}
			jQ(this).focus(function () {
				if (jQ('body').hasClass('boost-pfs-ada')) {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				}
			});
		});
	}

	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true) {
			html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		}
		return html;
	}

	function normalizeMetafieldValue(value) {
		if (value == null) {
			return '';
		}

		if (typeof value === 'object') {
			return String(value.value || value.text || '').trim();
		}

		return String(value).trim();
	}

	function getProductPromoCallout(data) {
		var metafields = data.metafields || [];
		var calloutField = metafields.find(function (field) {
			return field.key === 'callout_message' && (!field.namespace || field.namespace === 'promo_callouts');
		});
		var colorField = metafields.find(function (field) {
			return field.key === 'callout_color' && (!field.namespace || field.namespace === 'promo_callouts');
		});

		var message = normalizeMetafieldValue(calloutField && calloutField.value);
		var color = normalizeMetafieldValue(colorField && colorField.value);

		return {
			message: message,
			color: color
		};
	}

	function buildPromoCalloutHtml(message, color, promoClass) {
		var calloutClass = 'card-information__callout';
		if (promoClass) {
			calloutClass += ' ' + promoClass;
		}
		var calloutStyle = color ? ' style="color: ' + color + '"' : '';

		return (
			'<div class="card-information__callout-wrapper">' +
			'<p class="' + calloutClass + '"' + calloutStyle + '>' + message + '</p>' +
			'</div>'
		);
	}

	function isPromoCalloutsEnabled(config) {
		return config.promo_callouts_enabled === true ||
			config.promo_callouts_enabled === 'true' ||
			config.promo_callouts_enabled === 1;
	}

	function productHasSetTag(data) {
		var tags = data.tags;

		if (Array.isArray(tags)) {
			return tags.indexOf('set') !== -1;
		}

		if (typeof tags === 'string') {
			return tags.split(',').map(function (tag) {
				return tag.trim();
			}).indexOf('set') !== -1;
		}

		return false;
	}

	function getCollectionPromoCallout(data, config) {
		var excludedHandles = (config.promo_callout_excluded_collections || 'sets')
			.split(',')
			.map(function (handle) { return handle.trim().toLowerCase(); })
			.filter(Boolean);
		var collectionHandle = (config.collection_handle || '').toLowerCase();

		if (excludedHandles.indexOf(collectionHandle) !== -1) {
			return null;
		}

		if (productHasSetTag(data)) {
			return null;
		}

		var calloutMessage = normalizeMetafieldValue(config.collection_callout_message);
		if (!isPromoCalloutsEnabled(config) || !calloutMessage) {
			return null;
		}

		return {
			message: calloutMessage,
			color: normalizeMetafieldValue(config.collection_callout_color)
		};
	}

	function buildPromoCallout(data) {
		var config = boostPFSThemeConfig.custom || {};
		var collectionCallout = getCollectionPromoCallout(data, config);

		if (collectionCallout && collectionCallout.message) {
			return buildPromoCalloutHtml(
				collectionCallout.message,
				collectionCallout.color,
				''
			);
		}

		var productCallout = getProductPromoCallout(data);
		if (productCallout.message) {
			return buildPromoCalloutHtml(
				productCallout.message,
				productCallout.color,
				productCallout.color ? '' : 'card-information__callout--promo'
			);
		}

		// No callout for this product, but the line still holds its place so a card whose
		// neighbour HAS one does not sit 16px higher in the row. Mirrors reserve_space in
		// snippets/product-promo-callout.liquid; height comes from min-height in card-product.scss.
		return (
			'<div class="card-information__callout-wrapper">' +
			'<p class="card-information__callout card-information__callout--promo" aria-hidden="true"></p>' +
			'</div>'
		);
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var isSelected = ''
					if (paramSort == k) {
						isSelected = 'selected="selected"'
					}
					sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function () {
		jQ('.collection-filters__sort').change(function (e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).val());
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});
	}

	Filter.prototype.afterGetFilterData = function (data, eventType, eventInfo) {
		// Check the case when API returns 0 product on first load
		if (data && Array.isArray(data.products)
			&& data.products.length == 0
			&& typeof boostPFSAppConfig.general.collection_product_count != 'undefined'
			&& data.products.length != boostPFSAppConfig.general.collection_product_count) {
			// Check if first load
			if (eventType == 'init' && !Settings.general.productAndVariantAvailable
				&& !Globals.hasFilterOptionParam
				&& typeof FilterApi.beforeCall != 'function'
				&& typeof FilterApi.beforeCallAsync != 'function') {

				this.errorFilterCallback();
				return;
			}
		}
		prefetchDecimalPricingProducts(data && data.products);
		// Pass check, call setData
		this.setData(data, eventType, eventInfo);
	}
	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {
		if (!data) data = this.data;
		refreshDecimalPricingCards(data);
		const collectionId = boostPFSAppConfig.general.collection_id;
		const collectionTitle = boostPFSAppConfig.general.collection_title;
		window.trackEvents.viewItemList({
			products: data,
			itemListId: collectionId,
			itemListName: collectionTitle,
			normalizePrice: false,
		});

		this.productItems.forEach(({ $element, data }, index) => {
			const link = $element?.find("a");
			if (!link?.attr("href")?.includes("/products/")) {
				return;
			}
			link.on("click", () => {
				const product = {
					id: data.id,
					title: data.title,
					vendor: data.vendor,
					type: data.product_type,
					variants: data.variants,
				};
				window.trackEvents.selectItem({
					product,
					index,
					itemListId: collectionId,
					itemListName: collectionTitle,
					normalizePrice: false,
				});
			});
		});

		let button_selectors = document.querySelectorAll('.js-open-selectors:not([data-drawer-trigger])');
		if (button_selectors.length > 0) {
			for (let i = 0; i < button_selectors.length; i++) {
				button_selectors[i].addEventListener('click', function (e) {
					e.preventDefault();
					if (this.classList?.contains('disabled') || this.hasAttribute('outofstock')) {
						return false;
					}
					// Featured cards put the button in `.featured-product-card__footer`, a sibling of
					// `.option-selector`, so scope the lookup to the card rather than the button's parent.
					const selectorHost = this.closest('.card-information__wrapper') || this.parentElement;
					const optionSelector = selectorHost?.querySelector('.option-selector');
					if (!optionSelector) { return false; }
					optionSelector.style.maxHeight = 'initial';
					optionSelector.style.overflow = 'visible';
				});
			}
		}

		let buttons = document.querySelectorAll('.option-selector label');
		if (buttons.length > 0) {
			for (let i = 0; i < buttons.length; i++) {
				buttons[i].addEventListener('click', function (e) {
					e.preventDefault();
					const gwpVariant = getGwpProduct(data);
					if (this.classList?.contains('disabled') || this.hasAttribute('outofstock')) {
						return false;
					}

					// The featured-card swatches live inside a
					// `.featured-product-card__option-track` wrapper, so
					// `parentElement.parentElement` no longer reaches the
					// button. Walk up to the card instead.
					const infoWrapper = this.closest('.card-information__wrapper')
						|| this.closest('[data-featured-product-card]')
						|| this.closest('.card-wrapper');
					const atcButton = infoWrapper?.querySelector('.js-open-selectors');

					let buttons_inner = this.parentElement.querySelectorAll('label');
					for (let j = 0; j < buttons_inner.length; j++) {
						buttons_inner[j]?.classList?.remove('active');
					}
					this.classList?.add('active');
					let variant_id = this.dataset.variantId;
					// `atcButton` above walks up to the card. The old
					// `parentElement.parentElement` hop assumed labels were direct children of
					// `.option-selector`; with the option-track wrapper it resolves to the
					// selector itself and finds nothing, so swatch clicks did nothing.
					var cartButton = atcButton;
					if (!cartButton) return;

					cartButton.setAttribute('data-selected-variant', variant_id);
					if (gwpVariant) {
						cartButton.setAttribute('data-gwp-variant', gwpVariant);
					}

					window.variants_selected = variant_id;
					updateProductCartButtonPrice(cartButton, resolveSwatchVariantPrice(this));
					cartButton.querySelector('.button-text').textContent = 'Add to Bag';
					cartButton.removeEventListener('click', function () { });
					setAttributes(cartButton, {
						'data-drawer-trigger': '',
						'aria-controls': 'mini-cart',
						'aria-expanded': 'false'
					});
				});
			}
		}

		let button_selectors_singleV = document.querySelectorAll('.product-cart-button[data-variant-id]');
		for (let i = 0; i < button_selectors_singleV.length; i++) {
			button_selectors_singleV[i].addEventListener('click', function (e) {
				e.preventDefault();
				let variant_id = this.dataset.variantId;
				let xmlhttp = new XMLHttpRequest();
				xmlhttp.onreadystatechange = function () {
					if (xmlhttp.readyState == XMLHttpRequest.DONE) {
						if (xmlhttp.status == 400) {
							alert('There was an error 400');
						}
						else {
							alert('something else other than 200 was returned');
						}
					}
				};

				xmlhttp.open("POST", "/cart/add", true);
				xmlhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
				xmlhttp.send('id=' + variant_id);
			});
		}

		// Re-bind the featured product card carousel + swatch interactions to
		// cards Boost just injected. Uses the shared API from
		// scripts/partials/featured-product-card.js.
		if (window.FeaturedProductCard && typeof window.FeaturedProductCard.init === 'function') {
			var productGrid = document.getElementById('main-collection-product-grid') ||
				document.querySelector('.boost-pfs-filter-products') ||
				document;
			window.FeaturedProductCard.init(productGrid);
		}

		var url = new URL(window.location.href);
		var c = url.searchParams.get("page");
		if (c == null) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	}

	// Build Additional Elements
	Filter.prototype.afterRender = function (data, eventType) {
		if (!data) data = this.data;
		let li = document.createElement('li');
		if (document.querySelector('.boost-pfs-filter-clear') != null) {
			document.querySelector('.boost-pfs-filter-clear').textContent = 'All';
			li.classList.add('boost-pfs-filter-option-item');
			li.classList.add('boost-pfs-filter-option-label');
			li.appendChild(document.querySelector('.boost-pfs-filter-clear'));
		}
		let selected_element = document.querySelector('.boost-pfs-filter-option-label.selected'),
			sort_width;
		if (document.querySelector('.collection-filters__item.sorting') != null) {
			sort_width = document.querySelector('.collection-filters__item.sorting').clientWidth;
			document.querySelector('.center_filter').style.width = sort_width + 'px';
			document.querySelector('.center_filter').style.display = 'block';
		}


		if (!selected_element) {
			li.classList.add('selected');
		}
		document.querySelector('.boost-pfs-filter-option-item-list')?.prepend(li);
		if (document.querySelector('.boost-pfs-filter-option-title-heading') != null) {
			document.querySelector('.boost-pfs-filter-option-title-heading').click();
		}

		if (document.querySelector('.boost-pfs-filter-clear') != null) {
			document.querySelector('.boost-pfs-filter-clear').addEventListener('click', function () {
				setTimeout(() => {
					if (document.querySelector('.boost-pfs-filter-option-title-heading') != null && document.querySelector('.boost-pfs-filter-option')?.classList.contains('boost-pfs-filter-option-collapsed')) {
						document.querySelector('.boost-pfs-filter-option')?.classList.remove('boost-pfs-filter-option-collapsed');
						document.querySelector('.boost-pfs-filter-option-title-heading').click();
					}
				}, 1000);
			});
		}
		let filter_labels = document.querySelectorAll('.boost-pfs-filter-option-item');
		if (filter_labels.length > 0) {
			for (let i = 0; i < filter_labels.length; i++) {
				filter_labels[i].addEventListener('click', function () {
					setTimeout(() => {
						document.querySelector('.boost-pfs-filter-option-title-heading').click();
					}, 300);
				});
			}
		}
	};

	/************************** END BUILD TOOLBAR **************************/
})();